import { FacilityRole } from "src/api/facilityRoles";
import { FACILITY_ROLES } from "src/constants/facility";
import { SessionType } from "src/modules/interface";

export const convertMilitaryTime = (time: number) => {
  const hour = time > 12 ? time - 12 : time;
  const meridiem = time > 12 ? "pm" : "am";

  return { hour, meridiem };
};

export const isAdmin = (admin: boolean, sessionUser: SessionType["session"]["user"]) => {
  return (admin || sessionUser?.access?.includes(FACILITY_ROLES.ADMIN)) ?? false;
};

export const getSortedRoles = (roles: FacilityRole[]) =>
  roles.sort((a, b) => a.position - b.position);
